import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    orderSummaryTotal: {
        paddingBlock: theme.spacing(1),
    },
    orderSummaryTotalTitle: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightBold,
        marginBottom: theme.spacing(1),
    },
}));
